export function definedOrThrow(variableName: string, value?: string): string {
  /* istanbul ignore next */
  if (!value) {
    throw new Error(
      `Missing environment variable process.env.${variableName}, you need to provide it for the application to run.`,
    );
  }
  return value;
}
